export enum VoucherHistoryOperations {
  Modified = 'Geändert',
  Added = 'Hinzugefügt'
}
